import React from "react";

export default function SubSubMenuForm(props) {
    return <>
        <div className="modal modal-blur fade" id={props.modalID ?? "modal-report"} tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Main Menu Form</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Main Menu</label>
                                <select className="form-control" name="MainMenuID" id="MainMenuID" value={props.formData.MainMenuID} onChange={props.onEdit}>
                                    <option value="">Select Main Menu</option>
                                    {
                                        props.menuList.length > 0 && props.menuList.map((item, index)=> {
                                            return (
                                                <option key={index} value={item.EntryID}>{item.MenuName}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Sub Menu</label>
                                <select className="form-control" name="SubMenuID" id="SubMenuID" value={props.formData.SubMenuID} onChange={props.onEdit}>
                                    <option value="">Select Sub Menu</option>
                                    {
                                        props.optionSubMenuList.length > 0 && props.optionSubMenuList.map((item, index)=> {
                                            return (
                                                <option key={index} value={item.EntryID}>{item.SubMenuName}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Sub Sub Menu Name</label>
                                <input
                                    type="text"
                                    name="SubSubMenuName"
                                    className="form-control"
                                    id="SubSubMenuName"
                                    value={props.formData.SubSubMenuName}
                                    onChange={props.onEdit}
                                    placeholder="Sub Sub Menu Name"
                                />
                            </div>
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Sub Sub Menu Link</label>
                                <input
                                    type="text"
                                    name="SubSubMenuLink"
                                    className="form-control"
                                    id="SubSubMenuLink"
                                    value={props.formData.SubSubMenuLink}
                                    onChange={props.onEdit}
                                    placeholder="Sub Sub Menu Link"
                                />
                            </div>
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Visibility</label>
                                <select className="form-control" name="Visibility" id="Visibility" value={props.formData.Visibility} onChange={props.onEdit}>
                                    <option value="">Select Visibility</option>
                                    <option value="1">Show</option>
                                    <option value="2">Hide</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a href="#" id="closeModal3" className="btn btn-link link-secondary" data-bs-dismiss="modal">
                            Cancel
                        </a>
                        {
                            props.IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={props.onSubmit} className="btn btn-primary ms-auto">
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24"
                                                 height="24"
                                                 viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                                                 strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                        </svg>
                                             Submit
                                        </span>
                                </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}